import { TweenMax } from 'gsap';
import { Rectangle } from 'pixi.js';
import Core from '../../../Core/Core';
import { app } from '../../../index';
import { createOutlineText } from '../../../Utils/Utils';
import { NewsTab } from './NewsTab';
import Viewport from 'pixi-viewport';
import { PopupPage } from '../../Shared/PopupPage';

export interface INews {
    header: string;
    text: string;
    date: number; // YYYYMMDD
}

export class News extends PopupPage {
    private containerWidth: number;
    private containerHeight: number;
    private news: INews[];
    private scrollContainer: PIXI.Container;
    private newsContainer: Viewport;

    constructor(width: number, height: number, news: INews[]) {
        super();

        this.containerWidth = width;
        this.containerHeight = height;
        this.news = news;
        this.scrollContainer = new PIXI.Container();

        const mask = new PIXI.Graphics();
        mask.beginFill(0x000000);
        mask.drawRoundedRect(0, 0, width, height, 10);
        this.addChild(mask);
        this.scrollContainer.mask = mask;
        this.addChild(this.scrollContainer);

        const glow = new PIXI.Sprite(PIXI.utils.TextureCache['commonui/opt-in_icon_rays']);
        glow.anchor.set(0.5);
        glow.scale.set(0.7);
        glow.x = width * 0.15;
        glow.y = -height * 0.2;

        const letter = new PIXI.Sprite(PIXI.utils.TextureCache['mapui/socialhub-news']);
        letter.anchor.set(0.5);
        letter.x = glow.x;
        letter.y = glow.y;

        const disclamer = createOutlineText(
            Core.local.getText('disclamerNews'),
            new Rectangle(0, 0, width * 0.7, height * 0.2),
            'Baloo',
            28,
            30,
            0xffffff,
            0x006073
        );
        disclamer.anchor.set(0.5);
        disclamer.x = width * 0.6;
        disclamer.y = -height * 0.2;

        this.addChild(glow, letter, disclamer);

        this.createContent();

        this.createViewport().catch(err => {
            console.log(['error with news createViewport', err]);
        });
    }

    public cleanUp() {
        this.newsContainer.removeAllListeners();
        TweenMax.killChildTweensOf(this, true);
        this.newsContainer.destroy();
    }

    private createContent() {
        if (this.news) {
            let sortedNews: INews[] = [];
            if (this.news.length > 1) {
                sortedNews = this.news.sort((a, b) => b.date - a.date);
                // iap news should not show on ios, we will need to change remove index until it is removed completely
                if (!Core.sdk.payments.enabled) {
                    sortedNews.splice(1, 1);
                }
            } else {
                sortedNews = this.news;
            }
            sortedNews.forEach((element, index) => {
                const newsTab = new NewsTab(
                    this.containerWidth,
                    this.containerHeight,
                    element.header,
                    element.text,
                    element.date
                );
                this.scrollContainer.addChild(newsTab);
                newsTab.pivot.y = -newsTab.height / 2;
                newsTab.x = this.containerWidth / 2;
                newsTab.y = index * newsTab.height + 10;
            });
        } else {
            console.debug('No news data!');
        }
    }

    private async createViewport() {
        const wHeight = this.scrollContainer.height + 15;

        const newsContainer = new Viewport({
            screenWidth: this.containerWidth,
            screenHeight: this.containerHeight,
            worldWidth: this.containerWidth,
            worldHeight: wHeight,
            interaction: app.renderer.plugins.interaction,
        });
        this.newsContainer = newsContainer;
        this.newsContainer.drag().decelerate();
        this.newsContainer.clamp({
            left: true,
            right: true,
            top: true,
            bottom: wHeight,
        });
        this.addChild(this.newsContainer);
        this.newsContainer.addChild(this.scrollContainer);
    }
}
